import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addLanguage } from "../../../../redux/slices/multiUrl";
import LanguageItem from "./LanguageItem";
import { Button } from "react-bootstrap";
import { PlusIcon } from "../svg";

export default function LanguageOption({ error }) {
  const { languages, lang } = useSelector((state) => ({
    languages: state.multiUrl.languages,
    lang: state.changeLang.language.stepTwo.multiUrl,
  }));
  const dispatch = useDispatch();

  return (
    <>
      {languages.map((item, index) => (
        <LanguageItem
          key={item.id}
          language={item}
          languageIndex={index + 1}
          error={error}
        />
      ))}

      {languages.length < 10 && (
        <Button
          variant="outline-secondary"
          onClick={() => dispatch(addLanguage())}
          size="sm"
          className="d-flex justify-between align-items-center gap-2 mb-4"
        >
          <PlusIcon /> {lang[4]}
        </Button>
      )}
    </>
  );
}
